export const showSubscriptionAlert = {
    on: null
}